import React, { IframeHTMLAttributes, useEffect, useRef, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/loader.css'
import styled from 'styled-components'
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface Props extends IframeHTMLAttributes<HTMLIFrameElement> {
  showLoader?: boolean
}

/**
 * Auto-resizing iFrame. This React component supports all attributes of the
 * normal iFrame element, and passes them on unchanged.
 *
 * The following attributes are already set, but can be overwritten:
 *
 * - `allowTransparency`
 */
const IFrame = styled.iframe<{ $iframeHeight: number }>`
  min-height: ${(props) => props.$iframeHeight}px;
  border: none;
  width: 100%;
  overflow: hidden;
`
export function AutofitIFrame(props: Props) {
  const iframeElement = useRef<HTMLIFrameElement>(null)
  const [iframeHeight, setiFrameHeight] = useState<number>(250)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  // add all necessary code here
  // HA

  const datawrapperHeightListener = (event: MessageEvent) => {
    // For our standalones
    if (event.origin.includes('interaktiv.')) {
      setiFrameHeight(event.data.height)
    }
    // Okay, so far, this only works with data wrapper charts
    if (
      event.origin.includes('datawrapper.dwcdn.net') &&
      typeof event.data === 'object' &&
      'datawrapper-height' in event.data
    ) {
      const [id, height] = Object.entries(event.data['datawrapper-height'])[0]
      if (props.src && props.src.includes(id)) {
        setiFrameHeight(height as number)
      }
    }
  }

  useEffect(() => {
    window.addEventListener('message', datawrapperHeightListener)
    return () => {
      window.removeEventListener('message', datawrapperHeightListener)
    }
  }, [])

  const hideSpinner = () => {
    setIsLoading(false)
  }
  return (
    <>
      {props.showLoader ? (
        isLoading ? (
          <div className='ui active centered inline loader' />
        ) : null
      ) : null}
      <IFrame
        $iframeHeight={iframeHeight}
        ref={iframeElement}
        onLoad={hideSpinner}
        scrolling='no'
        {...props}
      />
    </>
  )
}
